export enum ActivityStatus {
    LINKED = "linked",
    CLOSED = "closed",
    COMPLETED = "completed",
    PENDING = "pending",
}
